import React from 'react'
import { Link } from 'react-router-dom'
import SubmitButton from 'Components/Form/SubmitButton'
import TickedIcon from 'Assets/Images/icons/ticked'
import { PATHS } from 'Config/Routing/paths'

export const MessagePasswordRequestSendUnstyled = props => (
  <div className={props.className}>
    <div className="wrapper">
      <h1>
        <TickedIcon />
        Password Request Sent
      </h1>
      <p>
        We’ve sent your password request to <br />
        <span>{props.email}</span>
      </p>
      <Link to={PATHS.main.login}>
        <SubmitButton value="Go Back to Log In" />
      </Link>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Message/PasswordRequestSend/unstyled.js